<!--The content below is only a placeholder and can be replaced.-->
<!-- <div style="text-align:center">
    <h1>
        Welcome to {{ title }}!
    </h1>
    <div ng-view></div>
   </div>

<ul>
    <li>
        <h2><a rel="noopener" routerLink="/general-master">General Masters</a></h2>
        <h2><a rel="noopener" routerLink="/login">Login</a></h2>
    </li>
</ul> -->


<router-outlet></router-outlet>
